import React, { useState, useContext } from "react";
import { LocalFileSystemID, SortOrder } from '../../shared/types';
import { FileAttributeType } from '../../shared/FileSystem';
import { AppSettingsContext } from '../../context/config';
import { parseURI } from '../../shared/utils/URI';
import Explorer from '../Explorer/Explorer';
import dirMenu from '../../menu/connectionsDir';
import fileMenu from '../../menu/connection';
import ConnectionForm from '../../modals/Connection/Connection';
import { useSubscribe } from '../../hooks';
import { CommandID } from '../../commands';
import { command$ } from '../../observables/command';
import NoConnections from '../NoConnections';
import classNames from 'classnames';
import styles from './Connections.less';
const settings = {
    columns: [
        {
            name: "name",
            type: FileAttributeType.String,
            title: "Name",
            visible: true,
            width: 300
        },
        {
            name: "modified",
            type: FileAttributeType.Date,
            title: "Last Modified",
            visible: true,
            width: 300
        }
    ],
    sort: ['name', SortOrder.Asc],
    history: [],
    filter: undefined
};
export default function Connections({ path, onChange, onSelect, connect, toolbar, onFocus, onBlur, tabindex }) {
    const appSettings = useContext(AppSettingsContext);
    const [selected, setSelected] = useState([]);
    const [menu, setMenu] = useState([]);
    const [connectionFile, setConnectionFile] = useState('');
    useSubscribe(() => command$.subscribe(cmd => {
        if (cmd.id == CommandID.Edit && cmd.uri) {
            const { id, path } = parseURI(cmd.uri);
            if (id == LocalFileSystemID && path.startsWith(appSettings.connections)) {
                setConnectionFile(path);
            }
        }
    }), []);
    const onContextMenu = (file, dir) => {
        const { path } = parseURI(file);
        setMenu(dir ?
            dirMenu(path, selected, path == appSettings.connections) :
            fileMenu(path, selected, () => connect(path)));
    };
    return React.createElement("div", { className: classNames(styles.root) },
        React.createElement(Explorer, { icon: 'cloud_upload', connection: LocalFileSystemID, settings: settings, path: path, fixedRoot: appSettings.connections, onChange: onChange, onSelect: (paths) => { setSelected(paths); onSelect(paths); }, onOpen: connect, onMenu: onContextMenu, contextMenu: menu, toolbar: toolbar, tabindex: tabindex, onNewFile: uri => setConnectionFile(parseURI(uri).path), onFocus: onFocus, onBlur: onBlur },
            React.createElement(NoConnections, null)),
        React.createElement(ConnectionForm, { file: connectionFile, onConnect: connect, onClose: () => setConnectionFile('') }));
}
